export const whatsAppLinkApi =
  'https://api.whatsapp.com/send/?phone=5555997265220&text=Fale+conosco%21&type=phone_number&app_absent=0';
